import { useTranslation } from "react-i18next"

export default function MoneyBackGuarantee() {
  const { t } = useTranslation()

  return (
    <div className="bg-custom-teal-light rounded-3xl p-8 text-center shadow-xs">
      <h2 className="text-custom-charcoal mb-6 text-2xl font-bold sm:text-3xl">
        {t("pages.checkout.plans.moneyBackGuaranteeComponent.title")}
      </h2>
      <p className="text-base leading-relaxed text-gray-600 sm:text-lg">
        {t("pages.checkout.plans.moneyBackGuaranteeComponent.description")}
      </p>
    </div>
  )
}
